import { HTMLAttributes, useEffect, useState } from 'react';
import LogoLoadingGifImage from '@/dashboard/assets/gif/gif_logo_loading.gif';
import LogoLoadingImage from '@/dashboard/assets/images/loading-logo.svg';
import clsx from 'clsx';

type LogoLoadingProps = HTMLAttributes<HTMLDivElement> & {
  labelClass?: string;
  label?: string;
  subTitle?: string;
  showMask?: boolean;
  size?: 'normal' | 'small';
};

const LogoLoading = (props: LogoLoadingProps) => {
  const { label, className, labelClass, showMask = true, subTitle, size } = props;
  const [logoStyle, setLogoStyle] = useState({ width: '80px', height: '80px' });

  /**
   * effects
   */
  useEffect(() => {
    if (size === 'small') {
      setLogoStyle({ width: '40px', height: '40px' });
    }
  }, [size]);

  return (
    <div className={clsx(`inset-0 left-0 top-0 z-40 flex h-full w-full items-center justify-center  backdrop-blur-xl`, { absolute: !className, 'bg-white/60': showMask }, className)}>
      <div className="flex flex-col items-center">
        <div className="relative flex items-center justify-center" style={logoStyle}>
          <img className="absolute h-full w-full" src={LogoLoadingGifImage.src} />
          <img className="h-1/2 w-1/2" src={LogoLoadingImage} />
        </div>

        {label && <div className={clsx('mt-1 text-center text-base font-bold', labelClass)}>{label}</div>}
        {subTitle && <p className="mt-2 text-center text-xs font-medium">{subTitle}</p>}
      </div>
    </div>
  );
};

export default LogoLoading;
